import { Fragment } from "react";

// Tiny, safe formatter: paragraphs, bullet/numbered lists, **bold**. No HTML injection.
function inline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i} className="font-bold text-q-text">{part.slice(2, -2)}</strong> : <Fragment key={i}>{part}</Fragment>);
}

export default function Rich({ text }) {
  const blocks = [];
  let list = null;
  (text || "").split("\n").forEach((raw) => {
    const line = raw.trimEnd();
    const m = line.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
    if (m) {
      if (!list) { list = { ordered: /^\s*\d/.test(line), items: [] }; blocks.push(list); }
      list.items.push(m[1]);
      return;
    }
    list = null;
    if (line.replace(/^#+\s*/, "").trim()) blocks.push(line.replace(/^#+\s*/, ""));
  });
  return (
    <div className="space-y-2 break-words leading-relaxed">
      {blocks.map((b, i) => (typeof b === "string" ? <p key={i}>{inline(b)}</p> : (
        b.ordered
          ? <ol key={i} className="list-decimal space-y-1 pl-5">{b.items.map((t, j) => <li key={j}>{inline(t)}</li>)}</ol>
          : <ul key={i} className="list-disc space-y-1 pl-5">{b.items.map((t, j) => <li key={j}>{inline(t)}</li>)}</ul>
      )))}
    </div>
  );
}
